import createInsertButtons from './insert-buttons.js';
import createInlineButtons from './inline-buttons.js';
import 'wix-rich-content-editor-common';
import '../defaults.js';
import '../icons/InsertPluginIcon.js';
import 'react';
import 'wix-rich-content-plugin-commons';
import 'lodash';
import '../types.js';
import '../modals.js';
import './file-upload-settings.js';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import '../pdfViewer/pdfConsts.js';
import '../icons/fullViewerIcon.js';
import '../icons/miniViewerIcon.js';
import '../icons/MediaReplaceIcon.js';

const createToolbar = ({
  settings,
  t,
  isMobile,
  experiments
}) => {
  return {
    InlineButtons: createInlineButtons({
      settings,
      t,
      isMobile,
      experiments
    }),
    InsertButtons: createInsertButtons({ settings, t, experiments }),
    name: "FileUpload"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
